import Big from 'big.js';
import numberFormatter from 'number-formatter';
import dayjs from 'dayjs';

export const formatterPercentage = (value, parameters) => {
  return `${formatterNumber(parameters.convertToHundred ? new Big(value).mul(new Big(100)).toNumber() : value, parameters)}%`;
};

export const formatterCurrency = (value, parameters) => {
  return `${formatterNumber(value, parameters)}€`;
};

export const formatterDate = (value, parameters) => {
  if(parameters?.format) {
    return `${dayjs(value).format(parameters?.format || 'YYYY/MM/DD, HH:mm:ss')}`;
  }
  else {
    return `${dayjs(value).toISOString()}`;
  }
};

export const formatterNumber = (value, parameters) => {
  const parametersExtended = { ...parameters, roundingMode: Big.roundDown }
  if (value === undefined || value == null)
    return '-';

  try {
    if (parameters && parametersExtended.decimals !== undefined) {
      const roundedValue = new Big(value).round(parametersExtended.decimals, parametersExtended.roundingMode);
      return numberFormatter(`#,##0.${Array(parametersExtended.decimals + 1).join("0")}`, roundedValue)
    }
    else if (parametersExtended && parametersExtended.maxDecimals !== undefined && parametersExtended.minDecimals !== undefined) {
      const roundedValue = new Big(value).round(parametersExtended.maxDecimals, parametersExtended.roundingMode);
      return numberFormatter(`#,##0.${Array(parametersExtended.minDecimals + 1).join("0")}${Array(parametersExtended.maxDecimals - parametersExtended.minDecimals + 1).join("#")}`, roundedValue)
    }
    else {
      return numberFormatter("#,##0.##########", value);
    }
  }
  catch (err) {
    return null
  }
};
